/**
 * Admin Hooks Index
 *
 * Exports all admin hooks for easy importing.
 *
 * @since 1.0.0
 */

// Existing hooks
export { useTabs } from './use-tabs';
export type { PaginationInfo, UseTabsParams, UseTabsReturn } from './use-tabs/types';

// Global tabs hook
export { useGlobalTabs } from './use-global-tabs';
export type {
  RedFoxTab,
  RedFoxTabsParams,
  UseGlobalTabsParams,
  UseGlobalTabsReturn,
} from './use-global-tabs/types';

// Navigation guard hook
export { useNavigationGuard } from './use-navigation-guard';

// Debounce hook
export { useDebounce } from './use-debounce';
export type { UseDebounceParams, UseDebounceReturn } from './use-debounce/types';

// Notifications hook
export { useNotifications } from './use-notifications';
